import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
const Users = () => {
  const [users, setUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [filterText, setFilterText] = useState("");
  const history = useHistory();

  const fetchUser = async () => {
    try {
      const response = await api.post(`/user/get`);
      if (response.data.success) {
        setUser(response.data.user);
      } else {
        setError("User not found");
      }
    } catch (err) {
      setError("Error fetching user details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const filteredItems = users.filter((item) => {
    const text = filterText.toLowerCase();

    const name = String(item.name || "").toLowerCase();
    const username = String(item.username || "").toLowerCase();
    const email = String(item.email || "").toLowerCase();
    const phone = String(item.phone || "").toLowerCase();

    return (
      name.includes(text) ||
      username.includes(text) ||
      email.includes(text) ||
      phone.includes(text)
    );
  });

  const deleteUser = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/user/delete/${id}`);
      if (response) {
        fetchUser();
        toast.success("User Delete Successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const addUser = async (e) => {
    try {
      e.preventDefault();
      localStorage.setItem("user-list", null);
      history.push("add-user");
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "300px",
    },
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
      width: "300px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "300px",
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      width: "300px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button className="btn btn-lg" onClick={(e) => deleteUser(e, row.id)}>
            <i className="icon-trash-2"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>User List</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/" style={{ textDecoration: "none" }}>
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">User List</div>
              </li>
            </ul>
          </div>
          {/* <!-- product-list --> */}
          <div className="wg-box">
            <div className="flex justify-end">
              <Link
                className="tf-button style-1 w208"
                // to="add-product"
                onClick={(e) => addUser(e)}
                style={{
                  textDecoration: "none",
                }}
              >
                <i className="icon-plus"></i>Add new
              </Link>
            </div>

            {error && <p className="text-danger">{error}</p>}

            {/* Search Input */}
            <div className="datatable-container">
              <div className="datatable-header">
                <input
                  type="text"
                  placeholder="Search user..."
                  className="datatable-search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
                {filterText && (
                  <button
                    className="datatable-clear"
                    onClick={() => setFilterText("")}
                  >
                    ✕
                  </button>
                )}
              </div>
              <DataTable
                columns={columns}
                data={filteredItems}
                progressPending={loading}
                pagination
                highlightOnHover
                striped
                responsive
                defaultSortField="name"
              />
              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Users;
